export const environment = {
  production: true,
  environment: 'production',
  apiUrl: 'https://api.speero.net/api',
  cfAccessClientSecret: 'cfAccessClientSecret',
  homeUrl: 'https://speero.net',
  discoverUrl: 'https://speero.net/parts/filter'
};